// Promo 5 — "Receipts" (cert-heavy, builds trust)
import { PromoStage, BgPhoto, PHOTOS, FULL_PB } from "@/pages/promo/_stage";
import { motion } from "framer-motion";

const SLIDES = [
  {
    id: "open",
    duration: 2200,
    bg: "#0A0A0A",
    full: true,
    render: () => (
      <>
        <BgPhoto src={PHOTOS.about} kenBurns="in" />
        <div className="absolute inset-0 bg-gradient-to-b from-black/30 via-black/55 to-black/90" />
        <div className="absolute inset-0 flex flex-col justify-end px-16" style={{ paddingBottom: FULL_PB + 20 }}>
          <motion.p initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ duration: 0.5 }} className="text-[#FF1B91] uppercase tracking-[0.5em] text-sm font-bold mb-5">
            / Receipts
          </motion.p>
          <motion.h1 initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.7 }} className="font-display font-black uppercase text-white leading-[0.85] tracking-tighter" style={{ fontSize: "150px" }}>
            Not a<br />
            <span className="text-[#FF1B91]">fitfluencer.</span><br />
            A coach.
          </motion.h1>
        </div>
      </>
    ),
  },
  {
    id: "nasm",
    duration: 1600,
    bg: "#FF1B91",
    render: () => (
      <div className="flex flex-col items-center justify-center w-full h-full text-center">
        <motion.p initial={{ opacity: 0, y: 12 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.4 }} className="text-white uppercase tracking-[0.5em] text-sm font-bold mb-6">
          / 01
        </motion.p>
        <motion.p initial={{ opacity: 0, scale: 0.85 }} animate={{ opacity: 1, scale: 1 }} transition={{ duration: 0.5 }} className="font-display font-black uppercase text-white leading-[0.85] tracking-tighter" style={{ fontSize: "260px" }}>
          NASM
        </motion.p>
        <motion.p initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ duration: 0.4, delay: 0.35 }} className="mt-4 text-white text-3xl font-bold uppercase tracking-tight">
          Certified Personal Trainer
        </motion.p>
      </div>
    ),
  },
  {
    id: "nfpt",
    duration: 1600,
    bg: "#0A0A0A",
    render: () => (
      <div className="flex flex-col items-center justify-center w-full h-full text-center">
        <motion.p initial={{ opacity: 0, y: 12 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.4 }} className="text-[#FF1B91] uppercase tracking-[0.5em] text-sm font-bold mb-6">
          / 02
        </motion.p>
        <motion.p initial={{ opacity: 0, scale: 0.85 }} animate={{ opacity: 1, scale: 1 }} transition={{ duration: 0.5 }} className="font-display font-black uppercase text-[#FF1B91] leading-[0.85] tracking-tighter" style={{ fontSize: "260px" }}>
          NFPT
        </motion.p>
        <motion.p initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ duration: 0.4, delay: 0.35 }} className="mt-4 text-white text-3xl font-bold uppercase tracking-tight">
          Pro Trainer
        </motion.p>
      </div>
    ),
  },
  {
    id: "cnc",
    duration: 1600,
    bg: "#FF1B91",
    render: () => (
      <div className="flex flex-col items-center justify-center w-full h-full text-center">
        <motion.p initial={{ opacity: 0, y: 12 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.4 }} className="text-white uppercase tracking-[0.5em] text-sm font-bold mb-6">
          / 03
        </motion.p>
        <motion.p initial={{ opacity: 0, scale: 0.85 }} animate={{ opacity: 1, scale: 1 }} transition={{ duration: 0.5 }} className="font-display font-black uppercase text-white leading-[0.85] tracking-tighter" style={{ fontSize: "260px" }}>
          CNC
        </motion.p>
        <motion.p initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ duration: 0.4, delay: 0.35 }} className="mt-4 text-white text-3xl font-bold uppercase tracking-tight">
          Nutrition Coach · NASM
        </motion.p>
      </div>
    ),
  },
  {
    id: "cpr",
    duration: 1600,
    bg: "#0A0A0A",
    render: () => (
      <div className="flex flex-col items-center justify-center w-full h-full text-center">
        <motion.p initial={{ opacity: 0, y: 12 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.4 }} className="text-[#FF1B91] uppercase tracking-[0.5em] text-sm font-bold mb-6">
          / 04
        </motion.p>
        <motion.p initial={{ opacity: 0, scale: 0.85 }} animate={{ opacity: 1, scale: 1 }} transition={{ duration: 0.5 }} className="font-display font-black uppercase text-white leading-[0.85] tracking-tighter" style={{ fontSize: "200px" }}>
          CPR<br /><span className="text-[#FF1B91]">/ AED</span>
        </motion.p>
        <motion.p initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ duration: 0.4, delay: 0.35 }} className="mt-4 text-white text-3xl font-bold uppercase tracking-tight">
          Adult · Child · Infant
        </motion.p>
      </div>
    ),
  },
  {
    id: "insured",
    duration: 1800,
    bg: "#FF1B91",
    render: () => (
      <div className="flex flex-col items-center justify-center w-full h-full text-center">
        <motion.p initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ duration: 0.4 }} className="text-white uppercase tracking-[0.5em] text-sm font-bold mb-6">
          / + Liability Insured
        </motion.p>
        <motion.p initial={{ opacity: 0, scale: 0.85 }} animate={{ opacity: 1, scale: 1 }} transition={{ duration: 0.5 }} className="font-display font-black uppercase text-white leading-[0.85] tracking-tighter" style={{ fontSize: "200px" }}>
          ERGO<br />
          <span className="font-brush font-normal normal-case -rotate-3 inline-block" style={{ fontSize: "180px" }}>Next.</span>
        </motion.p>
        <motion.p initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ duration: 0.4, delay: 0.35 }} className="mt-4 text-white text-2xl font-bold uppercase tracking-tight">
          Fully covered. So is your goal.
        </motion.p>
      </div>
    ),
  },
  {
    id: "cta",
    duration: 4600,
    bg: "#0A0A0A",
    render: () => (
      <div className="flex flex-col items-center justify-center w-full h-full text-center">
        <motion.p initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ duration: 0.4 }} className="text-[#FF1B91] uppercase tracking-[0.5em] text-sm font-bold mb-10">
          / Train with someone qualified
        </motion.p>
        <motion.h2 initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.55 }} className="font-display font-black uppercase text-white leading-[0.85] tracking-tighter" style={{ fontSize: "180px" }}>
          Sweat<br />
          <span className="font-brush font-normal normal-case text-[#FF1B91] -rotate-3 inline-block" style={{ fontSize: "200px" }}>With Slay.</span>
        </motion.h2>
        <motion.p initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ duration: 0.5, delay: 0.7 }} className="mt-10 text-white text-4xl font-bold tracking-tight">
          sweatwithslay.com
        </motion.p>
      </div>
    ),
  },
];

export default function Promo5() { return <PromoStage slides={SLIDES} />; }
